<template lang="pug">
  .section-2.learn
    .block-wrap
      .learn-wrap
        .btns
          a.main-btn.col-white.bg-red(href="http://bixter.com/learnearn/" target="_blank") {{ gettext('LEARN&EARN') }}
          a.main-btn.col-white.bg-black(:href="commentsLink" target="_blank") {{ gettext('TRAINEES ABOUT US') }}
</template>

<script>
import { gettext } from '@/services/TranslateHandler'

export default {
  data () {
    return {
      comments: {
        'en': 'http://bixter.com/testimonials-en/',
        'uk': 'http://bixter.com/testimonials-ua/',
        'ru': 'http://bixter.com/testimonials-ru/'
      }
    }
  },
  methods: {
    gettext: gettext
  },
  computed: {
    commentsLink () {
      return this.comments[this.$route.params.lang] || this.comments['en']
    }
  }
}
</script>

<style lang="scss" src="./styles.scss"></style>



// WEBPACK FOOTER //
// src/pages/agricultural-trainee/parts/learn/index.vue